<template>
  <div>
    <div class="dash-heading"><i class="fa fa-globe" />&nbsp;Project Summary</div><br />

    <el-row>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" align="left">
        <sites-stats-table :stats="stats" />
      </el-col>

      <el-col :xs="24" :sm="12" :md="12" :lg="12" align="right">
        <sites-chart :show-legend="false" :stats="stats" />
      </el-col>

      <!-- Ways Summary Report -->
      <el-col v-if="isTowerCo()" :md="24" :lg="6" align="center">
        <ways-summary-report />
      </el-col>

      <el-col v-if="isTowerCo()" :span="24">
        <sharing-summary-report />
      </el-col>

    </el-row>


    <el-row>
      <div v-if="isTowerCo()" class="dash-heading">Requests</div>
      <requests-report :summary="true" />
    </el-row>

    <el-row>
      <div class="dash-heading">Operations</div>
      <op-stats  />
    </el-row>

    <div v-if="isTelco() || canAccess('project|maintenance|management')">
      <el-row>
        <div class="dash-heading">Requests Calendar</div>
      </el-row>

      <events-calendar category="requests" />

    </div>

  </div>
</template>

<script>

import EventsCalendar from '@/components/atoms/EventsCalendar'

import SitesChart from '@/components/dashboard/charts/SitesChart'
import SitesStatsTable from '@/components/dashboard/sites/SitesStatsTable'

import SharingSummaryReport from '@/components/dashboard/sharers/SharingSummaryReport'
import WaysSummaryReport from '@/components/dashboard/sharers/WaysSummaryReport'

import RequestsReport from '@/components/dashboard/requests/RequestsReport'
import OpStats from '@/components/dashboard/OpStats'

export default {

  components: {
    EventsCalendar,
    SitesChart,
    SitesStatsTable,
    SharingSummaryReport,
    RequestsReport,
    OpStats,
    WaysSummaryReport
  },

  data () {

    return {
      stats: null
    }

  },

  created () {
    this.stats = this.getStats()
  }


}

</script>
